module.exports = __webpack_public_path__ + "static/img/14000261.26a087cc.png";